import React, { useEffect, useState, useRef } from "react";
import NavBar from "../components/navbar";
import Presentation from "../components/presentation";
import Competences from "../components/competences";
import Projets from "../components/projets";
import Experiences from "../components/experience";
import Formations from "../components/formation";
import Contact from "../components/contact";

export default function Home() {
  const [page, setPage] = useState("home");
  const [isTransitioning, setIsTransitioning] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    [
      window,
      document.documentElement,
      document.body,
      ...document.querySelectorAll("[data-drei-html]"),
      ...document.querySelectorAll(".bg-gray-50"),
      ...document.querySelectorAll('[style*="overflow"]'),
    ].forEach((el) => {
      try {
        if (el.scrollTo) el.scrollTo(0, 0);
        if (typeof el.scrollTop !== "undefined") el.scrollTop = 0;
        if (typeof el.scrollLeft !== "undefined") el.scrollLeft = 0;
      } catch (e) {}
    });
  }, [page]);

  const handlePageChange = (newPage) => {
    if (newPage === page) return;

    setIsTransitioning(true);

    const scrollToTop = () => {
      [
        window,
        document.documentElement,
        document.body,
        ...document.querySelectorAll("[data-drei-html]"),
        ...document.querySelectorAll(".bg-gray-50"),
        ...document.querySelectorAll('[style*="overflow"]'),
      ].forEach((el) => {
        try {
          if (el.scrollTo) el.scrollTo(0, 0);
          if (typeof el.scrollTop !== "undefined") el.scrollTop = 0;
          if (typeof el.scrollLeft !== "undefined") el.scrollLeft = 0;
        } catch (e) {}
      });
    };
    scrollToTop();

    setTimeout(() => {
      setPage(newPage);
      scrollToTop();
      setIsTransitioning(false);
    }, 100);
  };

  const renderPageContent = () => {
    const pageMap = {
      home: <Presentation setPage={(page) => setPage(page)} />,
      skills: <Competences setPage={(page) => setPage(page)} />,
      projects: <Projets setPage={(page) => setPage(page)} />,
      experiences: <Experiences setPage={(page) => setPage(page)} />,
      formations: <Formations setPage={(page) => setPage(page)} />,
      contact: <Contact setPage={(page) => setPage(page)} />,
    };

    return pageMap[page] || <Presentation setPage={(page) => setPage(page)} />;
  };

  return (
    <div ref={containerRef} className="relative w-full min-h-screen">
      <NavBar setPage={handlePageChange} currentPage={page} />

      <main
        className={`transition-opacity duration-200 ease-in-out ${
          isTransitioning ? "opacity-0" : "opacity-100"
        }`}
        style={{
          minHeight: "100vh",
          position: "relative",
        }}
      >
        {renderPageContent()}
      </main>
    </div>
  );
}
